function e(e,r){return r||(r=e.slice(0)),Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(r)}}))}export{e as _};
//# sourceMappingURL=taggedTemplateLiteral-2207d3b5.js.map
